// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Llama, Llama as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared";
import { equal } from "@lg/shared";
import * as z from "zod";
import { immerable } from "immer";

const $schemas = new Map<string, z.ZodObject<any>>();
@jsonClass('Llama.Expense')
class Llama__Expense {
    @jsonProperty(() => Llama__Expense.Id)
    id: Llama__Expense.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "string" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "receiptDate", "expenseDate", "name", "description", "totalAmount", "vatAmount", "tipAmount", "currency", "currency$id", "category", "category$id", "locations", "chargedInInvoiceId", "status", "status$id", "isLocked", "reimbursementDate", "employeeEmail", "paidBy", "paidBy$id", "emailHtml", "isChargeable", "project", "projectId", "receipts", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "receiptDate", "expenseDate", "name", "description", "totalAmount", "vatAmount", "tipAmount", "currency", "currency$id", "category", "category$id", "locations", "chargedInInvoiceId", "status", "status$id", "isLocked", "reimbursementDate", "employeeEmail", "paidBy", "paidBy$id", "emailHtml", "isChargeable", "project", "projectId", "receipts", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "receiptDate", "expenseDate", "name", "description", "totalAmount", "vatAmount", "tipAmount", "currency", "category", "locations", "chargedInInvoiceId", "status", "isLocked", "reimbursementDate", "employeeEmail", "paidBy", "emailHtml", "isChargeable", "project", "projectId", "receipts", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "receiptDate": "Date", "expenseDate": "Date", "name": "string", "description": "string", "totalAmount": "number", "vatAmount": "number", "tipAmount": "number", "currency": "Llama.Currency", "currency$id": "string", "category": "Llama.ExpenseCategory", "category$id": "string", "locations": "string[]", "chargedInInvoiceId": "string", "status": "Llama.ExpenseStatus", "status$id": "string", "isLocked": "boolean", "reimbursementDate": "Date", "employeeEmail": "string", "paidBy": "Llama.ExpensePaidBy", "paidBy$id": "string", "emailHtml": "string", "isChargeable": "boolean", "project": "Llama.Project", "projectId": "Llama.Project.Id", "receipts": "Llama.ExpenseReceipt[]", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "string" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["currency", "category", "status", "paidBy"] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ project: () => Llama.Project } as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ receipts: () => Llama.ExpenseReceipt } as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = String;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θreceiptDate? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θexpenseDate? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θname? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θdescription? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θtotalAmount? = Signals.proxySignalDeferred<number>(() => undefined);
    private readonly θvatAmount? = Signals.proxySignalDeferred<number>(() => undefined);
    private readonly θtipAmount? = Signals.proxySignalDeferred<number>(() => undefined);
    private readonly θcurrency = Signals.proxySignalDeferred<This.Currency>(() => new This.Currency());
    private readonly θcategory = Signals.proxySignalDeferred<This.ExpenseCategory>(() => new This.ExpenseCategory());
    private readonly θlocations? = Signals.proxySignalDeferred<string[]>(() => undefined);
    private readonly θchargedInInvoiceId? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θstatus = Signals.proxySignalDeferred<This.ExpenseStatus>(() => new This.ExpenseStatus());
    private readonly θisLocked? = Signals.proxySignalDeferred<boolean>(() => false);
    private readonly θreimbursementDate? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θemployeeEmail? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θpaidBy = Signals.proxySignalDeferred<This.ExpensePaidBy>(() => new This.ExpensePaidBy());
    private readonly θemailHtml? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θisChargeable? = Signals.proxySignalDeferred<boolean>(() => false);
    private readonly θproject? = Signals.proxySignalDeferred<Llama.Project>(() => undefined);
    private readonly θprojectId? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θreceipts? = Signals.proxySignalDeferred<Llama.ExpenseReceipt[]>(() => undefined);
    private readonly θcreatedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θupdatedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θdeletedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θversionNumber? = Signals.proxySignalDeferred<number>(() => undefined);

    static get __type(): 'Llama.Expense' {
        return 'Llama.Expense'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Llama.Expense' {
        return 'Llama.Expense'
    }

    static get __baseType(): 'Llama.Expense' {
        return 'Llama.Expense'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Llama.Expense' {
        return 'Llama.Expense'
    }

    get [BoInfoSymbol]() {
        return Llama__Expense[BoInfoSymbol]
    }

    get receiptDate(): Date {
        return this.θreceiptDate?.()
    }

    set receiptDate(receiptDate) {
        this.θreceiptDate.set(LowgileDataUtil.coerceDataType(receiptDate, 'Date', false, true))
    }

    get expenseDate(): Date {
        return this.θexpenseDate?.()
    }

    set expenseDate(expenseDate) {
        this.θexpenseDate.set(LowgileDataUtil.coerceDataType(expenseDate, 'Date', false, true))
    }

    get name(): string {
        return this.θname?.()
    }

    set name(name) {
        this.θname.set(LowgileDataUtil.coerceDataType(name, 'string', false, true))
    }

    get description(): string {
        return this.θdescription?.()
    }

    set description(description) {
        this.θdescription.set(LowgileDataUtil.coerceDataType(description, 'string', false, true))
    }

    get totalAmount(): number {
        return this.θtotalAmount?.()
    }

    set totalAmount(totalAmount) {
        this.θtotalAmount.set(LowgileDataUtil.coerceDataType(totalAmount, 'number', false, true))
    }

    get vatAmount(): number {
        return this.θvatAmount?.()
    }

    set vatAmount(vatAmount) {
        this.θvatAmount.set(LowgileDataUtil.coerceDataType(vatAmount, 'number', false, true))
    }

    get tipAmount(): number {
        return this.θtipAmount?.()
    }

    set tipAmount(tipAmount) {
        this.θtipAmount.set(LowgileDataUtil.coerceDataType(tipAmount, 'number', false, true))
    }

    get currency(): This.Currency {
        return this.θcurrency?.()
    }

    set currency(currency: This.Currency | This.Currency.Id) {
        this.θcurrency().θupdate(currency)
    }

    @jsonProperty(String)
    get 'currency$id'(): This.Currency.Id {
        return this.θcurrency?.()?.id
    }

    set 'currency$id'(currency: string) {
        this.θcurrency().θupdate(currency as This.Currency.Id)
    }

    get category(): This.ExpenseCategory {
        return this.θcategory?.()
    }

    set category(category: This.ExpenseCategory | This.ExpenseCategory.Id) {
        this.θcategory().θupdate(category)
    }

    @jsonProperty(String)
    get 'category$id'(): This.ExpenseCategory.Id {
        return this.θcategory?.()?.id
    }

    set 'category$id'(category: string) {
        this.θcategory().θupdate(category as This.ExpenseCategory.Id)
    }

    get locations(): string[] {
        return this.θlocations?.()
    }

    set locations(locations) {
        this.θlocations.set(LowgileDataUtil.coerceDataType(locations, 'string[]', false, true))
    }

    get chargedInInvoiceId(): string {
        return this.θchargedInInvoiceId?.()
    }

    set chargedInInvoiceId(chargedInInvoiceId) {
        this.θchargedInInvoiceId.set(LowgileDataUtil.coerceDataType(chargedInInvoiceId, 'string', false, true))
    }

    get status(): This.ExpenseStatus {
        return this.θstatus?.()
    }

    set status(status: This.ExpenseStatus | This.ExpenseStatus.Id) {
        this.θstatus().θupdate(status)
    }

    @jsonProperty(String)
    get 'status$id'(): This.ExpenseStatus.Id {
        return this.θstatus?.()?.id
    }

    set 'status$id'(status: string) {
        this.θstatus().θupdate(status as This.ExpenseStatus.Id)
    }

    get isLocked(): boolean {
        return this.θisLocked?.()
    }

    set isLocked(isLocked) {
        this.θisLocked.set(LowgileDataUtil.coerceDataType(isLocked, 'boolean', false, true))
    }

    get reimbursementDate(): Date {
        return this.θreimbursementDate?.()
    }

    set reimbursementDate(reimbursementDate) {
        this.θreimbursementDate.set(LowgileDataUtil.coerceDataType(reimbursementDate, 'Date', false, true))
    }

    get employeeEmail(): string {
        return this.θemployeeEmail?.()
    }

    set employeeEmail(employeeEmail) {
        this.θemployeeEmail.set(LowgileDataUtil.coerceDataType(employeeEmail, 'string', false, true))
    }

    get paidBy(): This.ExpensePaidBy {
        return this.θpaidBy?.()
    }

    set paidBy(paidBy: This.ExpensePaidBy | This.ExpensePaidBy.Id) {
        this.θpaidBy().θupdate(paidBy)
    }

    @jsonProperty(String)
    get 'paidBy$id'(): This.ExpensePaidBy.Id {
        return this.θpaidBy?.()?.id
    }

    set 'paidBy$id'(paidBy: string) {
        this.θpaidBy().θupdate(paidBy as This.ExpensePaidBy.Id)
    }

    get emailHtml(): string {
        return this.θemailHtml?.()
    }

    set emailHtml(emailHtml) {
        this.θemailHtml.set(LowgileDataUtil.coerceDataType(emailHtml, 'string', false, true))
    }

    get isChargeable(): boolean {
        return this.θisChargeable?.()
    }

    set isChargeable(isChargeable) {
        this.θisChargeable.set(LowgileDataUtil.coerceDataType(isChargeable, 'boolean', false, true))
    }

    get project(): Llama.Project {
        return this.θproject?.()
    }

    set project(project) {
        this.θproject.set(LowgileDataUtil.coerceDataType(project, Llama.Project, false, true))
        if (project) {
            this.θprojectId.set(project.id)
        } else if (project === null && project) {
            this.θprojectId.set(null)
        }
    }

    get projectId(): Llama.Project.Id {
        return this.θprojectId?.()
    }

    set projectId(projectId) {
        if (projectId === null) this.θproject.set(null)
        if (this.project?.id && projectId != this.project.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θprojectId.set(LowgileDataUtil.coerceDataType(projectId, 'string', false, true))
    }

    get receipts(): Llama.ExpenseReceipt[] {
        return this.θreceipts?.()
    }

    set receipts(receipts) {
        this.θreceipts.set(LowgileDataUtil.coerceDataType(receipts, Llama.ExpenseReceipt, true, true))
        this.receipts?.forEach?.(item => { if (item && "expense" in item) item.expense = this as any })
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Llama__Expense>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                receipts: [],
                ...init
            }

        }

        LowgileDataUtil.assignCommonProperties(this, init)
        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Llama__Expense()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Llama__Expense>, restrictToClass?: Class<Partial<Llama__Expense>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = ""
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            receiptDate: z.coerce.date(),
            expenseDate: z.coerce.date(),
            name: z.string(),
            description: z.string(),
            totalAmount: z.number(),
            vatAmount: z.number(),
            tipAmount: z.number(),
            get currency() { return Llama.Currency.$getSchema() },
            get category() { return Llama.ExpenseCategory.$getSchema() },
            locations: z.string().array(),
            chargedInInvoiceId: z.string(),
            get status() { return Llama.ExpenseStatus.$getSchema() },
            isLocked: z.boolean(),
            reimbursementDate: z.coerce.date(),
            employeeEmail: z.string(),
            get paidBy() { return Llama.ExpensePaidBy.$getSchema() },
            emailHtml: z.string(),
            isChargeable: z.boolean(),
            get project() { return Llama.Project.$getSchema() },
            projectId: Llama.Project.$getSchema().shape.id,
            get receipts() { return Llama.ExpenseReceipt.$getSchema().array() },
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return Llama__Expense.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('receiptDate', 'expenseDate', 'name', 'description', 'totalAmount', 'vatAmount', 'tipAmount', 'currency$id', 'category$id', 'locations', 'chargedInInvoiceId', 'status$id', 'isLocked', 'reimbursementDate', 'employeeEmail', 'paidBy$id', 'emailHtml', 'isChargeable', 'project', 'projectId', 'receipts', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Llama__Expense {
        return equal(this, other)
    }
}

namespace Llama__Expense { }

export import Expense = Llama__Expense
setTimeout(() => {
    jsonProperty(() => Date)(Llama__Expense.prototype, 'receiptDate')
    jsonProperty(() => Date)(Llama__Expense.prototype, 'expenseDate')
    jsonProperty(() => String)(Llama__Expense.prototype, 'name')
    jsonProperty(() => String)(Llama__Expense.prototype, 'description')
    jsonProperty(() => Number)(Llama__Expense.prototype, 'totalAmount')
    jsonProperty(() => Number)(Llama__Expense.prototype, 'vatAmount')
    jsonProperty(() => Number)(Llama__Expense.prototype, 'tipAmount')
    jsonArrayProperty(() => String)(Llama__Expense.prototype, 'locations')
    jsonProperty(() => String)(Llama__Expense.prototype, 'chargedInInvoiceId')
    jsonProperty(() => Boolean)(Llama__Expense.prototype, 'isLocked')
    jsonProperty(() => Date)(Llama__Expense.prototype, 'reimbursementDate')
    jsonProperty(() => String)(Llama__Expense.prototype, 'employeeEmail')
    jsonProperty(() => String)(Llama__Expense.prototype, 'emailHtml')
    jsonProperty(() => Boolean)(Llama__Expense.prototype, 'isChargeable')
    jsonProperty(() => Llama.Project)(Llama__Expense.prototype, 'project')
    jsonProperty(() => String)(Llama__Expense.prototype, 'projectId')
    jsonArrayProperty(() => Llama.ExpenseReceipt)(Llama__Expense.prototype, 'receipts')
    jsonProperty(() => Date)(Llama__Expense.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Llama__Expense.prototype, 'createdBy')
    jsonProperty(() => Date)(Llama__Expense.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Llama__Expense.prototype, 'updatedBy')
    jsonProperty(() => Date)(Llama__Expense.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Llama__Expense.prototype, 'deletedBy')
    jsonProperty(() => Number)(Llama__Expense.prototype, 'versionNumber')
})

export const ExpenseθId = String;

export type ExpenseθId = string;

namespace Llama__Expense {
    export type Id = NominalType<string, 'Llama.Expense'>

}
